import { createSelector } from '@app/utils/createSelector'

import { ApiError } from '@app/packages/api/errors'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { callApi } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'

import { routingDateSelector } from './routing'

export type YandexConfig = { client_id: string }

const yandexConfigSlice = createReduxSlice<SliceState<YandexConfig | null>>('yandex_config')

export const yandexConfigResultSelector = createSelector([yandexConfigSlice.selector, routingDateSelector], (sliceState, date) =>
  createLoadable(c =>
    withCheckedSliceState(c, {
      sliceState,
      slice: yandexConfigSlice,
      date: { date, expiresInMinutes: 30 },
      load: async dispatch => {
        const { getAuthYandexConfig } = await import('@app/packages/api/v3/actions/auth')
        try {
          const response = await dispatch(callApi(getAuthYandexConfig()))
          return { client_id: response.data.attributes.client_id }
        } catch (error) {
          if (error instanceof ApiError && error.status === 404) return null // 404 = feature not available
          throw error
        }
      },
    })
  )
)
